import Base from '../../_config/base';

class Footer extends Base {
  constructor(el) {
    super(el);

    const footerMenus = el.querySelectorAll('.footer__menu');
    if (footerMenus.length) {
      footerMenus.forEach((menu) => {
        menu.addEventListener('click', () => {
          menu.classList.toggle('active');
        });
      });
    }
  }
}

Footer.className = 'Footer';
export default Footer;
